import ContactUs from './ContactUs'

// importing helper components
import HeadingPart from '../../Helper/HeadingPart'

// importing constants
import headingPart from '../../../constants/headingPart'


const index = () => {
  return (
    <div className="w-full">
      <HeadingPart heading={headingPart.HEADING_WE_ARE_HERE} text={headingPart.TEXT_WE_ARE_HERE} order_1={2} />
      <div className="w-full">
        <ContactUs />
      </div>
    </div>
  )
}

export default index